import { get } from './';
export const getStyles = ({ locale } = {}) =>
  get(`/api/v1/styles?locale=${encodeURIComponent(locale ?? 'en')}`);
